//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import ItemId from '@models/ItemId';
import PartialCuid from '@models/PartialCuid';
import { UniversalItemType } from '@models/UniversalItemType';

export const itemToPartialCuid = (itemType: UniversalItemType, id: ItemId) => {
  return PartialCuid.build({
    itemType,
    id,
  });
};
